import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  tr,
  th,
  td,
  thead,
  Table,
  div,
  tbody,
  Button,
  Alert,
  DropdownButton,
  MenuItem,
  FormGroup,
  InputGroup,
  FormControl,
  Modal,
  ControlLabel
} from "react-bootstrap";
import { withRouter } from "react-router";
import { Breadcrumb as BreadcrumbComponent } from "../../../components";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";
import "../../../style/react-paginating.css";
import {
  redeem_voucher,
  getArchiveMerchantVoucherList,
  updateStatus,
  getMerchantDeals
} from "../../../redux/actions/voucherActions";
import moment from "moment";
import Dialog from "react-bootstrap-dialog";
import { CSVLink, csvLink } from "react-csv";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import { appConfig } from "../../../config";
import auth from "../../../services/auth";

const history = createBrowserHistory();

let isLoading = "false",
  headers = [],
  merchantDetails = [],
  userID = "";
let csvData = [];
class List extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    (this.csvLink = React.createRef()),
      (this.state = {
        voucherData: [],
        totalRecords: 0,
        limit: 25,
        search: "",
        perPage: 0,
        currentPage: 1,
        pageCount: 0,
        alertMessage: "",
        msgType: "success",
        path: ["Home", "Manage Archive Vouchers List"],
        show: false,
        voucherNumberSortIcon: "glyphicon glyphicon-sort-by-attributes-alt",
        userNameSortIcon: "glyphicon glyphicon-sort-by-attributes-alt",
        statusSortIcon: "glyphicon glyphicon-sort-by-attributes-alt",
        trackingNumberSortIcon: "glyphicon glyphicon-sort-by-attributes-alt",
        direction: "",
        orderBy: "",
        showDialog: false,
        promoid: "",
        show: false,
        deallist: [],
        dealID: "",
        defaultdealID: "",
        merchantName: "",
        expirationMonth: "",
        merchantlist: "",
        exceldata: [
          {
            voucherNumber: "",
            userName: "",
            dealText: "",
            status: "",
            createdOn: "",
            redeemed_at: ""
          }
        ],
        csvData: "",
      });
    this.handleSearch = this.handleSearch.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handlePageChange = page => {
    this.setState({
      currentPage: page
    });

    const postData = {
      page: page,
      limit: this.state.limit,
      search: this.state.search ? this.state.search : "",
      dealID: this.state.dealID
    };
    this.props.getArchiveMerchantVoucherList(postData);
  };

  handleSort = orderBy => e => {
    e.preventDefault();
    let direction;
    const sortIcon = `${orderBy}SortIcon`;
    if (this.state.direction === "") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-sort-by-attributes",
        direction: "ASC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "ASC") {
      direction = "DESC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-sort-by-attributes-alt",
        direction: "DESC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "DESC") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-sort-by-attributes",
        direction: "ASC",
        orderBy: orderBy
      });
    }
    this.props.getArchiveMerchantVoucherList({
      orderBy: orderBy,
      direction: direction,
      dealID: this.state.dealID,
      limit: this.state.limit 
    });
  };

  handleVoucher = (vaoucherID, vaoucherNotes) => {    
    this.handleDismiss();
    if(vaoucherNotes){
      this.dialog.show({
        body: "Are you sure you want to redeem this voucher?",
        actions: [
          Dialog.CancelAction(),
          Dialog.OKAction(() => {
            // this.confirmRedeem();
            const postdata = {
              voucherNumber: vaoucherID,
              note: vaoucherNotes,
            };
            this.props.redeem_voucher(postdata);
            isLoading = "true";
            this.handleShow();
          })
        ]
      });
    }else{
      alert('Notes is required!')
    }
  };

  componentWillMount() {
    this.handleDismiss();
    this.props.clearAlert();
    isLoading = "true";
    userID = this.props.match.params.userID
      ? this.props.match.params.userID
      : "";
    if (userID !== "") {
      this.props.getMerchantDeals(userID, {page: 0});
    } else {
      const userinfo = auth.getUserInfo();
      if (userinfo.user_id !== "") {
        this.props.getMerchantDeals(userinfo.user_id, {page: 0});
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    console.log('dev',nextProps);
    if (this.props.merchantarchiveVoucherList !== nextProps.merchantarchiveVoucherList) {
      if (nextProps.merchantarchiveVoucherList) {
        isLoading = "false";
        const setPageCount =
          nextProps.merchantarchiveVoucherList.data.total /
          nextProps.merchantarchiveVoucherList.data.per_page;
        this.setState({
          voucherData: nextProps.merchantarchiveVoucherList.data.data,
          totalRecords: nextProps.merchantarchiveVoucherList.data.total,
          perPage: nextProps.merchantarchiveVoucherList.data.per_page,
          pageCount: setPageCount
        });
        this.handleExport(nextProps.merchantarchiveVoucherList.full_data);
      }
    }

    if (this.props.redeemvoucher !== nextProps.redeemvoucher) {
      if (nextProps.redeem_voucher) {
        isLoading = "false";
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.redeemvoucher.message);        

        this.setState({ voucherData: nextProps.redeemvoucher.data });
      }
    }

    if (this.props.merchantdealList !== nextProps.merchantdealList) {
      if (nextProps.merchantdealList) {
        isLoading = "false";
        this.setState({ deallist: nextProps.merchantdealList.data });
      }
    }

    if (this.props.voucherStatus !== nextProps.voucherStatus) {
      if (nextProps.voucherStatus) {
        this.props.clearAlert();
        this.handleShow();
        if (nextProps.voucherStatus.message) {
          isLoading = "false";
          this.props.getVoucherList();
          this.props.renderAlert("success", nextProps.voucherStatus.message);
        }
      }
    }
    if (nextProps.message) {
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        isLoading = "false";
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
      }
    }
  }

  handleExport = data => {
    csvData = [
      [
      'Voucher Number',
      'Customer Name',
      'Status',
      'Redeemed By',
      'Redeemed At',
      ]
    ];

    {data &&
      data.map((data, keyIndex) =>
        csvData.push([
          data.voucherNumber, 
          data.userName, 
          data.status, 
          (data.status=='Redeemed' ? data.redeemedBy : ''),
          data.redeemed_at,
        ])
      )
    }

    this.setState({ csvData: csvData });
  }
  changeStatus = (voucherID, status) => {
    this.handleShow();
    isLoading = "true";
    let postdata = {
      status: status
    };
    this.props.updateStatus(voucherID, postdata);
  };

  handleSearch(e) {
    this.setState({ [e.target.name]: e.target.value });
    let searchstring = this.state.search.length > 1 ? this.state.search : "";
    const postData = {
      page: "1",
      limit: this.state.limit,
      search: searchstring,
      dealID: this.state.dealID
    };
    if (this.state.search.length !== 0) {
      this.props.getArchiveMerchantVoucherList(postData);
    }
  }

  handleChange(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }

    this.setState({ [e.target.name]: e.target.value });
    let postData = {
      dealID: e.target.value,
      limit: this.state.limit 
    };

    if (e.target.value !== "") {
    isLoading = "true";
      this.props.getArchiveMerchantVoucherList(postData);
      console.log(this.state.deallist);

      const selectedMerchant = this.state.deallist.find(
        k => k.dealID == e.target.value
      );
      this.setState({ merchantName: selectedMerchant.merchantName });
      this.setState({ expirationMonth: selectedMerchant.expirationMonth });
    }
  }

  fetchData = () => {
    let url = `${appConfig.api.url}vouchers/export-deal-vouchers/${
      this.state.dealID
    }`;
    window.location.href = url;
  };

  render() {
    let dealListItems;
    let dealListData = this.state.deallist ? this.state.deallist : [];

    if (dealListData !== "") {
      dealListItems = dealListData.map((el, key) => (
        <option key={key} value={el.dealID} style={{color: "black", fontSize: "14px", fontWeight: "100"}}>
          {el.OfferID}-{el.dealText}
        </option>
      ));
    }

    const { path } = this.state;
    const { currentPage, totalRecords, perPage, pageCount } = this.state;
    let voucherRow;
    let voucherListData = this.state.voucherData ? this.state.voucherData : "";
    if (!isEmpty(voucherListData) && this.state.dealID !== "") {
      voucherRow = voucherListData.map((voucher, index) => (
        <tr key={voucher.voucherID}>
          <td>{voucher.voucherNumber}</td>
          <td>{voucher.userName} </td>
          <td>{voucher.trackingNumber}</td>
          <td>{voucher.note}</td>
          <td>{voucher.status}</td>
          <td>{voucher.status=='Redeemed' ? voucher.redeemedBy : ''}</td>
          <td>{voucher.redeemed_at}</td>
          <td>
            <Button
              bsSize="xsmall"
              bsStyle="success"
              onClick={() =>
                this.context.router.history.push(`/printarchiveVouchers/${voucher.voucherID}`)
              }
            >
              {" "}
              View Voucher{" "}
            </Button>
            {voucher.status == "Active" ? (
              <Button
                bsSize="xsmall"
                bsStyle="info"
                onClick={() =>
                  this.context.router.history.push(`/editarchiveVoucher/${voucher.voucherID}/${userID}`)
                }
              >
                {" "}
                Redeem{" "}
              </Button>
            ) : (
              ""
            )}
            
          </td>
        </tr>
      ));
    } else {
      voucherRow = (
        <tr>
          <td>
            {" "}
            <span style={{ color: "red" }}>
              No voucher available for this offer!{" "}
            </span>{" "}
          </td>
        </tr>
      );
    }

    headers = [
      { label: "Voucher Number", key: "voucherNumber" },
      { label: "Purchaser", key: "userName" },
      { label: "Offer", key: "dealText" },
      { label: "Voucher Status", key: "status" },
      { label: "Purchase Timestamp", key: "createdOn" },
      { label: "Redeemed At", key: "redeemed_at" }
    ];

    return (
      <div>
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <Dialog
          ref={el => {
            this.dialog = el;
          }}
        />
        <div className="col-lg-12 user-list">
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 text-right">
              <Button
                bsSize="small"
                bsStyle="success"
                onClick={() => this.context.router.history.push(`/merchant/dashboard/${userID}`)}
              >
                Back
              </Button>
            </div>
          </div>

          <div className="panel">
            <header className="panel-heading"> Archive Vouchers List </header>
            <div className="panel-body">
              {this.state.show &&
                this.state.alertMessage !== "" && (
                  <div className="col-lg-12">
                    <Alert
                      bsStyle={this.state.msgType}
                      onDismiss={this.handleDismiss}
                    >
                      <strong>{this.state.msgType}:</strong>{" "}
                      {this.state.alertMessage}
                    </Alert>
                  </div>
                )}
              <div className="row">
                <div className="row">
                  {this.state.expirationMonth ? (
                    <div className="col-lg-12 text-right">
                      {" "}
                      Expires in {this.state.expirationMonth} month from the
                      purchase date{" "}
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="col-lg-12 text-left">
                    <FormGroup controlId="formdeallist">
                      <ControlLabel>{this.state.merchantName}</ControlLabel>

                      <FormControl
                        componentClass="select"
                        name="dealID"
                        onChange={this.handleChange}
                        style={{color: "red", fontSize: "15px", fontWeight: "600"}}
                      >
                        <option value="" style={{color: "black", fontSize: "14px", fontWeight: "100"}}>Select your offer</option>
                        {dealListItems}
                      </FormControl>
                    </FormGroup>
                  </div>
                </div>

                <div className="text-right">
                  <Row>
                    <Col>
                      {this.state.dealID !== "" ? (
                        <div>
                          {userID !== "" ? (
                            <Button
                              bsStyle="info"
                              type="submit"
                              onClick={() =>
                                this.context.router.history.push(
                                  `/samplevoucher/${
                                    this.state.dealID
                                  }/${userID}`
                                )
                              }
                            >
                              Sample Voucher{" "}
                            </Button>
                          ) : (
                            <Button
                              bsStyle="info"
                              type="submit"
                              onClick={() =>
                                this.context.router.history.push(
                                  `/samplevoucher/${this.state.dealID}`
                                )
                              }
                            >
                              Sample Voucher{" "}
                            </Button>
                          )}

                          <CSVLink
                            data={this.state.csvData}
                            filename={"voucher.csv"}
                            className="btn btn-info"
                          >
                            Export CSV
                          </CSVLink>

                          {/*<Button
                                                      bsStyle="info"
                                                      onClick={this.fetchData.bind(this)}
                                                    >
                                                      {" "}
                                                      Export as CSV{" "}
                                                    </Button>*/}

                          <Button
                            bsStyle="info"
                            onClick={() =>
                              this.context.router.history.push(
                                `/archivevoucher/list/print/${this.state.dealID}`
                              )
                            }
                          >
                            {" "}
                            Print List
                          </Button>
                        </div>
                      ) : (
                        ""
                      )}
                    </Col>
                  </Row>
                </div>
              </div>

              <div className="clearfix" />

              <div className="row m-t-15">
                <div className="col-lg-4 pull-right">
                  <FormGroup>
                    <InputGroup>
                      <FormControl
                        type="text"
                        name="search"
                        onChange={this.handleSearch}
                      />
                      <InputGroup.Addon>
                        <i className="glyphicon glyphicon-search" />
                      </InputGroup.Addon>
                    </InputGroup>
                  </FormGroup>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th onClick={this.handleSort("voucherNumber")}>
                          Voucher Number{" "}
                          <span
                            className={this.state.voucherNumberSortIcon}
                            aria-hidden="true"
                          />{" "}
                        </th>
                        <th onClick={this.handleSort("userName")}>
                          Customer{" "}
                          <span
                            className={this.state.userNameSortIcon}
                            aria-hidden="true"
                          />{" "}
                        </th>

                        <th onClick={this.handleSort("trackingNumber")}>
                          Tracking Number{" "}
                          <span
                            className={this.state.trackingNumberSortIcon}
                            aria-hidden="true"
                          />{" "}
                        </th>

                        <th>Notes </th>

                        <th onClick={this.handleSort("status")}>
                          Status{" "}
                          <span
                            className={this.state.statusSortIcon}
                            aria-hidden="true"
                          />
                        </th>
                        <th>Redeemed By</th>
                        <th>Redeemed At</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>{voucherRow}</tbody>
                  </table>

                  <div className="text-center">
                    <Pagination
                      total={totalRecords}
                      limit={perPage}
                      pageCount={5}
                      currentPage={currentPage}
                    >
                      {({
                        pages,
                        currentPage,
                        hasNextPage,
                        hasPreviousPage,
                        previousPage,
                        nextPage,
                        totalPages,
                        getPageItemProps
                      }) => (
                        <div className="pagination">
                          <button
                            {...getPageItemProps({
                              pageValue: 1,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            first
                          </button>

                          {hasPreviousPage && (
                            <button
                              {...getPageItemProps({
                                pageValue: previousPage,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              {"<"}
                            </button>
                          )}

                          {pages.map(page => {
                            let activePage = null;
                            if (currentPage === page) {
                              activePage = {
                                backgroundColor: "#ccc",
                                color: "#666"
                              };
                            }
                            return (
                              <button
                                key={page}
                                style={activePage}
                                {...getPageItemProps({
                                  pageValue: page,
                                  onPageChange: this.handlePageChange
                                })}
                              >
                                {page}
                              </button>
                            );
                          })}

                          {hasNextPage && (
                            <button
                              {...getPageItemProps({
                                pageValue: nextPage,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              {">"}
                            </button>
                          )}

                          <button
                            {...getPageItemProps({
                              pageValue: totalPages,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            last
                          </button>
                        </div>
                      )}
                    </Pagination>
                  </div>
                </div>
              </div>
              <div className="clearfix" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  merchantdealList: state.voucherReducer.merchantdealList,
  redeemvoucher: state.voucherReducer.redeemvoucher,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message,
  merchantarchiveVoucherList: state.voucherReducer.merchantarchiveVoucherList,
  voucherStatus: state.voucherReducer.voucherStatus
});

export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, {
    redeem_voucher,
    renderAlert,
    clearAlert,
    updateStatus,
    getArchiveMerchantVoucherList,
    getMerchantDeals
  })
)(List);


// WEBPACK FOOTER //
// ./src/app/views/merchant/archivevoucher/List.js